
import AudioFileAlbumCategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryResponse";
import { SLEEP_STORY_CATEGORY_CREATE, SLEEP_STORY_CATEGORY_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";

@Component
export default class MusicCategoriesPage extends Vue {
    @Inject('eventBus') eventBus: EventBus;
    getDataFunc = this.$api.SleepStoryService.getCategoriesAsync.bind(this.$api.SleepStoryService);
    removeFunc = this.$api.SleepStoryService.deleteCategoryAsync.bind(this.$api.SleepStoryService);
    columnNames = [
        '#',
        'Название',
        '',
        ''
    ];
    createRouteName = SLEEP_STORY_CATEGORY_CREATE;
    editRouteName = SLEEP_STORY_CATEGORY_EDIT;
    async startDelete(item: AudioFileAlbumCategoryResponse) {
        this.eventBus.deleteEntity.trigger({ id: item.Id });
    }
}
